module.exports = __webpack_public_path__ + "media/images/aloe/icons/line/status-70b04f115ba38b13c91939064654150f.svg";